// import React, { useCallback, useState } from 'react';
// import axios from "services/axios";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import FormInput from 'components/atoms/FormInput';
// import showPwd from "../../../assets/svg/show.svg";
// import hidePwd from "../../../assets/svg/hide.svg";
// import Button from 'components/atoms/Button';
// import Alert from 'components/atoms/Alert';
// import { BASE_URL } from 'services/http';
// import { handleException } from "utils";
// import Spinner from 'components/atoms/Spinner';

// const ResetPassword = () => {
//     const [loading, setLoading] = useState(false);
//     const [showTempPassword, setShowTempPassword] = useState(false);
//     const [showPassword, setShowPassword] = useState(false);
//     const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//     const [errorState, setErrorState] = useState(false);

//     const [oldPassword, setOldPassword] = useState("");
//     const [newPassword, setNewPassword] = useState("");
//     const [confirmPassword, setConfirmPassword] = useState("");

//     const [passwordErr, setPasswordErr] = useState("");

//     const location = useLocation();
//     const navigate = useNavigate();

//     const userEmail = location.state.email;
//     console.log("userEmail:", userEmail);

//     const formComplete = oldPassword && newPassword && confirmPassword;
//     const disableBtn = !formComplete || loading;

//     const validateUser = async (userData: any) => {
//         try {
//             const res = await axios.post(`${BASE_URL}authenticate`, userData, {
//                 headers: {
//                     "Content-Type": "application/json",
//                 },
//             });

//             if(res?.data?.responseCode === '00'){
//                 await ChangePasswordFunc(res.data.data.bearerToken);
//             }else{
//                 setLoading(false);
//                 Alert("error", res.data.message);
//             }

//         } catch (error) {
//             setLoading(false);
//             Alert("error", error);
//         }
//     }

//     const ChangePasswordFunc = useCallback(async (bearerToken?: string) => {
//         setLoading(true);
//         try {
//             const res = await axios.post(
//                 `${BASE_URL + 'user/change-password'}`,
//                 {
//                     otp: oldPassword,
//                     newPassword: newPassword,
//                     username: userEmail
//                 },
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         // "Authorization": `Bearer ${bearerToken}`,
//                         // "Public-Key": `${publicKey}`,
//                     },
//                 }
//             );
//             if (res.data.code === "error") {
//                 setLoading(false);
//                 Alert("error", res.data.message);
//             } else {
//                 setLoading(false);
//                 Alert("success", res.data.message);
//                 navigate('/auth/login');
//             }
//         } catch (error) {
//             setLoading(false);
//             setErrorState(true);
//             handleException(error);
//         }
//     }, [oldPassword, newPassword, confirmPassword]);

//     const handleSubmit = (e) => {
//         e.preventDefault(); 

//         if (!oldPassword || !newPassword || !confirmPassword) {
//             Alert("error", "Incomplete Form data input, please fill all fields");
//             return;
//         }

//         if (newPassword !== confirmPassword) {
//             Alert("error", "Password do not Match");
//             return;
//         }

//         return ChangePasswordFunc();

//         // return validateUser({
//         //     email: location?.state?.email,
//         //     password: oldPassword,
//         // });
//     }

//     return (
//         <div data-testid="reset-password-container" className="text-center bg-white py-6 w-full rounded-lg">
//             <span className="text-left flex flex-col gap-5">
//                 <p data-testid="reset-password-title" className="font-bold text-2xl leading-7">Reset Password</p>
//                 {/* <p className="font-normal text-base leading-7 mb-5 text-Black2"></p> */}
//             </span>

//             <FormInput
//                 type={showTempPassword ? "text" : "password"}
//                 name="passwd"
//                 placeholder="********"
//                 inputStyle="border border-transparent text-Black2 flex-row-reverse"
//                 label="Temporary Password"
//                 labelStyle="font-normal text-left text-Black2 mx-0 mt-6"
//                 onChange={(e) => setOldPassword(e.target.value)}
//                 value={oldPassword}
//                 validationErr={passwordErr}
//                 img={showTempPassword ? showPwd : hidePwd}
//                 imgStyle="cursor-pointer w-5 h-5 block"
//                 imgOnClick={() => setShowTempPassword((prevState) => !prevState)}
//             />
//             <FormInput
//                 type={showPassword ? "text" : "password"}
//                 name="passwd"
//                 placeholder="********"
//                 inputStyle="border border-transparent text-Black2 flex-row-reverse"
//                 label="New Password"
//                 labelStyle="font-normal text-left text-Black2 mx-0 mt-6"
//                 onChange={(e) => setNewPassword(e.target.value)}
//                 value={newPassword}
//                 validationErr={passwordErr}
//                 img={showPassword ? showPwd : hidePwd}
//                 imgStyle="cursor-pointer w-5 h-5 block"
//                 imgOnClick={() => setShowPassword((prevState) => !prevState)}
//             />
//             <FormInput
//                 type={showConfirmPassword ? "text" : "password"}
//                 name="passwd"
//                 placeholder="********"
//                 inputStyle="border border-transparent text-Black2 flex-row-reverse"
//                 label="Confirm Password"
//                 labelStyle="font-normal text-left text-Black2 mx-0 mt-6"
//                 onChange={(e) => setConfirmPassword(e.target.value)}
//                 value={confirmPassword}
//                 validationErr={passwordErr}
//                 img={showConfirmPassword ? showPwd : hidePwd}
//                 imgStyle="cursor-pointer w-5 h-5 block"
//                 imgOnClick={() => setShowConfirmPassword((prevState) => !prevState)}
//             />
//             <Button
//                 // onClick={ChangePasswordFunc}
//                 onClick={handleSubmit}
//                 btnType="submit"
//                 btnText={
//                     loading ? (
//                         <Spinner text="Loading..." textStyle="text-white" />
//                     ) : (
//                         "Change Password"
//                     )
//                 }
//                 btnStyle="mt-10 bg-black text-SecondaryAccent5 font-semibold text-sm leading-7 px-5 py-1 !rounded-lg w-full"
//                 disabled={disableBtn}
//             />
//             <span className="flex justify-left mt-5">
//                 <Link
//                     to="/auth/login"
//                     className="text-DarkBg3 hover:text-DarkBg3 font-bold text-sm leading-7 hover:underline hover:transition-all"
//                 >
//                     Return to Login
//                 </Link>
//             </span>
//         </div>
//     )
// }

// export default ResetPassword;


import React, { useCallback, useState } from "react";
import axios from "services/axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import FormInput from "components/atoms/FormInput";
import showPwd from "../../../assets/svg/show.svg";
import hidePwd from "../../../assets/svg/hide.svg";
import Button from "components/atoms/Button";
import Alert from "components/atoms/Alert";
import { BASE_URL } from "services/http";
import { handleException } from "utils";
import Spinner from "components/atoms/Spinner";
import { z } from "zod";
import { MdCancel } from "react-icons/md";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const passwordSchema = z
    .object({
        newPassword: z
            .string()
            .min(8, "At least 8 characters")
            .regex(/[A-Z]/, "At least one uppercase letter (A-Z)")
            .regex(/[a-z]/, "At least one lowercase letter (a-z)")
            .regex(/\d/, "At least one number (0-9)")
            .regex(/[!@#$%^&*(),.?":{}|<>]/, "At least one special character"),
        confirmPassword: z.string(),
    })
    .refine((data) => data.newPassword === data.confirmPassword, {
        message: "Passwords don't match",
        path: ["confirmPassword"],
    });

const passwordRules = [
    {
        id: "length",
        label: "At least 8 characters",
        test: (p: string) => p.length >= 8,
    },
    {
        id: "uppercase",
        label: "At least one uppercase letter (A-Z)",
        test: (p: string) => /[A-Z]/.test(p),
    },
    {
        id: "lowercase",
        label: "At least one lower letter (a-z)",
        test: (p: string) => /[a-z]/.test(p),
    },
    {
        id: "number",
        label: "At least one number (0–9)",
        test: (p: string) => /\d/.test(p),
    },
    {
        id: "special",
        label: "At least one special character",
        test: (p: string) => /[!@#$%^&*(),.?":{}|<>]/.test(p),
    },
];

const ResetPassword = () => {
    const [loading, setLoading] = useState(false);
    const [showTempPassword, setShowTempPassword] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [errorState, setErrorState] = useState(false);

    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [passwordErr, setPasswordErr] = useState("");

    const location = useLocation();
    const navigate = useNavigate();

    const allRulesPassed = passwordRules.every((rule) => rule.test(newPassword));
    const passwordsMatch =
        confirmPassword.length > 0 && newPassword === confirmPassword;

    const formComplete = oldPassword && newPassword && confirmPassword;

    const disableBtn =
        !formComplete || loading || !allRulesPassed || !passwordsMatch;

    const validationResult = passwordSchema.safeParse({
        newPassword,
        confirmPassword,
    });

    const fieldErrors = !validationResult.success
        ? (z.treeifyError(validationResult.error).properties ?? {})
        : {};

    const confirmError = fieldErrors.confirmPassword?.errors?.[0];

    const ChangePasswordFunc = useCallback(
        async (bearerToken?: string) => {
            setLoading(true);
            try {
                const res = await axios.post(
                    `${BASE_URL}reset-password`,
                    {
                        otp: oldPassword,
                        newPassword: newPassword,
                        username: location?.state?.email,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    },
                );
                if (res.data.code === "error") {
                    setLoading(false);
                    Alert("error", res.data.message);
                } else {
                    setLoading(false);
                    Alert("success", res.data.message);
                    navigate("/auth/login");
                }
            } catch (error) {
                setLoading(false);
                setErrorState(true);
                handleException(error);
            }
        },
        [oldPassword, newPassword, location?.state?.email, navigate],
    );

    const handleSubmit = (e) => {
        e.preventDefault();

        const result = passwordSchema.safeParse({ newPassword, confirmPassword });

        if (!result.success) {
            const firstError = result.error.issues[0].message;
            Alert("error", firstError);
            return;
        }

        return ChangePasswordFunc();
    };

    return (
        <div
            data-testid="reset-password-container"
            className="text-center bg-white py-6 w-full rounded-lg"
        >
            <span className="text-left flex flex-col gap-5">
                <p
                    data-testid="reset-password-title"
                    className="font-bold text-2xl leading-7"
                >
                    Reset Password
                </p>
            </span>

            <FormInput
                type={showTempPassword ? "text" : "password"}
                name="passwd"
                placeholder="********"
                inputStyle="border border-transparent text-Black2 flex-row-reverse"
                label="Temporary Password"
                labelStyle="font-normal text-left text-Black2 mx-0 mt-6"
                onChange={(e) => setOldPassword(e.target.value)}
                value={oldPassword}
                validationErr={passwordErr}
                img={showTempPassword ? showPwd : hidePwd}
                imgStyle="cursor-pointer w-5 h-5 block"
                imgOnClick={() => setShowTempPassword((prevState) => !prevState)}
            />
            <FormInput
                type={showPassword ? "text" : "password"}
                name="passwd"
                placeholder="********"
                inputStyle="border border-transparent text-Black2 flex-row-reverse"
                label="New Password"
                labelStyle="font-normal text-left text-Black2 mx-0 mt-6"
                onChange={(e) => setNewPassword(e.target.value)}
                value={newPassword}
                validationErr={passwordErr}
                img={showPassword ? showPwd : hidePwd}
                imgStyle="cursor-pointer w-5 h-5 block"
                imgOnClick={() => setShowPassword((prevState) => !prevState)}
            />

            <FormInput
                type={showConfirmPassword ? "text" : "password"}
                name="passwd"
                placeholder="********"
                inputStyle="border border-transparent text-Black2 flex-row-reverse"
                label="Confirm Password"
                labelStyle="font-normal text-left text-Black2 mx-0 mt-6"
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                validationErr={passwordErr}
                img={showConfirmPassword ? showPwd : hidePwd}
                imgStyle="cursor-pointer w-5 h-5 block"
                imgOnClick={() => setShowConfirmPassword((prevState) => !prevState)}
            />
            {newPassword.length > 0 && (
                <ul className="text-left mt-4 mb-1 space-y-1">
                    {passwordRules.map((rule) => {
                        const passed = rule.test(newPassword);
                        return (
                            <li key={rule.id} className="flex items-center gap-2 text-sm">
                                <span className={passed ? "text-green-600" : "text-red-600"}>
                                    {passed ? <IoMdCheckmarkCircleOutline /> : <MdCancel />}
                                </span>
                                <span className="text-gray-500">{rule.label}</span>
                            </li>
                        );
                    })}
                </ul>
            )}
            {confirmPassword.length > 0 && (
                <p className="text-sm text-left mt-1 flex items-center gap-2">
                    <span className={passwordsMatch ? "text-green-600" : "text-red-600"}>
                        {passwordsMatch ? <IoMdCheckmarkCircleOutline /> : <MdCancel />}
                    </span>
                    <span className="text-gray-500">
                        {passwordsMatch
                            ? "Passwords match"
                            : (confirmError ?? "Passwords don't match")}
                    </span>
                </p>
            )}
            <Button
                onClick={handleSubmit}
                btnType="submit"
                btnText={
                    loading ? (
                        <Spinner text="Loading..." textStyle="text-white" />
                    ) : (
                        "Change Password"
                    )
                }
                btnStyle="mt-10 bg-black text-SecondaryAccent5 font-semibold text-sm leading-7 px-5 py-1 !rounded-lg w-full"
                disabled={disableBtn}
            />
            <span className="flex justify-left mt-5">
                <Link
                    to="/auth/login"
                    className="text-DarkBg3 hover:text-DarkBg3 font-bold text-sm leading-7 hover:underline hover:transition-all"
                >
                    Return to Login
                </Link>
            </span>
        </div>
    );
};

export default ResetPassword;